// extracted by mini-css-extract-plugin
module.exports = {"adsWrapper":"XpaGoogleAdsPlaceholder_adsWrapper__fe4Nm","adsWrapperWithBg":"XpaGoogleAdsPlaceholder_adsWrapperWithBg__QcRmM"};